import {HEELIX_URL} from '../constants';

export default function redirectToHeelix() {
    window.location.replace(HEELIX_URL + '/cookie_login');
}